import { useEffect, useState } from 'react';
import { NavContainer, Left, Menu } from './navbar.styles';
//import NavMenuList from 'src/components/modals/navMenuList/NavMenuList';
import NavMenuList from 'src/components/Layout/navMenuList/NavMenuList';
import { signInSelector, signOutAll, userGroupSelector } from 'src/store/User/user.slice';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from 'src/utilities/UILibrary/UI/Button/Button';
import { useNavigate } from 'react-router-dom';
import { Squash as Hamburger } from 'hamburger-react';
import { useViewMobile } from 'src/hooks/useViewMobile';
import { breakpoints } from 'src/utilities/UIStyles/variables/breakpoints';
import { RootState, useAppThunkDispatch } from 'src/store/store';
import { useHandleLoginRedirect } from 'src/hooks/useHandleLoginRedirect';

const Navbar = () => {
  const [showMenuList, setShowMenuList] = useState(false);
  const navigate = useNavigate();
  const isMobile = useViewMobile(parseInt(breakpoints.desktop));
  const isSignedIn = useSelector(signInSelector);
  const dispatch = useAppThunkDispatch();
  const userGroup = useSelector(userGroupSelector);
  const onboarding = useSelector((state: RootState) => state.user?.currentUser?.onboarding);
  const { groupName, typeOfPerson } = useSelector((state: RootState) => state.user?.currentUser);
  const { handleRedirectFromLogin } = useHandleLoginRedirect();
  const [hiddenButton, setHiddenButton] = useState(false);

  useEffect(() => {
    if (
      location.pathname.includes('/inversionista') ||
      location.pathname.includes('/solicitante') ||
      isMobile === false
    ) {
      return setHiddenButton(true);
    }

    return setHiddenButton(false);
  }, [location.pathname, isMobile]);

  //Verificar signOut
  const handleLogout = async () => {
    try {
      dispatch(signOutAll());
      navigate('/');
    } catch (error) {
      console.error('ERROR en Signout', error);
    }
  };

  useEffect(() => {
    if (!isMobile) {
      document.body.style.overflow = 'auto';
      setShowMenuList(false);
      isSignedIn;
    }
  }, [isMobile]);

  const onChangeMenuList = () => {
    document.body.style.overflow = showMenuList ? 'auto' : 'hidden';

    return setShowMenuList(!showMenuList);
  };

  return (
    <NavContainer>
      <Left>
        <Link to="/">
          <img
            src="https://finsphera-webapp-resources.s3.amazonaws.com/icon_nav_finsphera.png"
            alt="logotipo finsphera"
          />
        </Link>
        <div className="menu-left">
          {isSignedIn && onboarding?.complete ? (
            userGroup === 'applicant' ? (
              <>
                {/* Items for applicants */}
                <Link to="/solicitante/dashboard">Home</Link>
                <Link to="/solicitante/dashboard/mi-perfil">Perfil</Link>
                <Link to="/solicitante/dashboard/crear-campaña">Crear campaña</Link>
                <Link to="/solicitante/dashboard/campañas">Mis campañas</Link>
              </>
            ) : userGroup === 'investor' ? (
              <>
                {/* Items for investors */}
                <Link to="/inversionista/dashboard">Home</Link>
                <Link to="/inversionista/dashboard/oportunidades">Oportunidades</Link>
                <Link to="/inversionista/dashboard/mi-perfil">Perfil</Link>
                <Link to="/inversionista/dashboard/cuenta-clabe">Información bancaria</Link>
              </>
            ) : (
              // User group unknown
              <></>
            )
          ) : isSignedIn ? (
            <>
              {/* Items for non-signed-in users */}
              <Link to="/quienes-somos">¿Quiénes somos?</Link>
              <Link to="/contratos-y-legal">Contratos e Información legal</Link>
              <Link to="/relacion-con-accionistas-comunidad">Accionistas</Link>
            </>
          ) : (
            <>
              <Link to="/inversionista/registrate">Inverte</Link>
              <Link to="/solicitante/inicio">Solicita crédito</Link>
              <Link to="/quienes-somos">¿Quiénes somos?</Link>
              <Link to="/contratos-y-legal">Contratos e Información legal</Link>
              <Link to="/relacion-con-accionistas-comunidad">Accionistas</Link>
            </>
          )}
        </div>
      </Left>
      <Menu>
        {isSignedIn ? (
          <>
            {hiddenButton ? null : (
              <Button
                className="flow-button"
                size="small"
                isSlim
                onClick={() =>
                  handleRedirectFromLogin(
                    { typeOfPerson, typeOfUser: groupName },
                    onboarding?.currentStep,
                    onboarding?.complete
                  )
                }
              >
                {onboarding?.complete ? 'Dashboard' : 'Completar registro'}
              </Button>
            )}
            <Button size="small" isSlim onClick={handleLogout}>
              Cerrar sesión
            </Button>
          </>
        ) : (
          <Button
            className="navbar-button"
            size="small"
            isSlim
            onClick={() => navigate('/iniciar-sesion')}
          >
            Ingresar
          </Button>
        )}
        <Hamburger toggled={showMenuList} toggle={onChangeMenuList} distance="sm" size={24} />
        <NavMenuList showMenuList={showMenuList} callback={onChangeMenuList} />
      </Menu>
    </NavContainer>
  );
};

export default Navbar;
